import React from 'react';
import {MutatingDots} from "react-loader-spinner";
import "./Style.scss";

export const LoadingAnimation = props => (
    <div className={"loader" + (props.className ? " loader--" + props.className : "")}>
        <MutatingDots />
    </div>
)